import { pressArticles } from '@data/siteData';
import { Card, CardContent } from '@components/ui/Card';
import { Newspaper, ExternalLink } from 'lucide-react';

export default function PressePage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Presse + Medien</h1>
          <p className="text-lg text-slate-400">
            Berichte und Artikel über die Alte Sternwarte Mannheim in den Medien.
          </p>
        </div>

        {/* Articles by Year */}
        <div className="space-y-6">
          {pressArticles.map((article, index) => (
            <Card key={index}>
              <CardContent className="flex gap-4 py-4">
                <div className="w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center shrink-0">
                  <Newspaper className="text-blue-400" size={20} />
                </div>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-blue-400 font-semibold">{article.year}</span>
                    <span className="text-slate-500">•</span>
                    <span className="text-slate-400">{article.source}</span>
                    {article.date && (
                      <>
                        <span className="text-slate-500">•</span>
                        <span className="text-slate-400">{article.date}</span>
                      </>
                    )}
                  </div>
                  <h3 className="text-white font-medium">{article.title}</h3>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Press Contact */}
        <div className="mt-12 bg-gradient-to-r from-blue-900/20 to-purple-900/20 rounded-xl p-6 border border-blue-800/30">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center shrink-0">
              <ExternalLink className="text-blue-400" size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-2">Pressekontakt</h2>
              <p className="text-slate-300">
                Für Presseanfragen wenden Sie sich bitte an:{" "}
                <a
                  href="mailto:kontakt@sternwarte-mannheim.de"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  kontakt@sternwarte-mannheim.de
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
